import React from 'react';

export const NewVehicle = React.lazy(() => import('./NewVehicle'));
export const ViewVehicle = React.lazy(() => import('./ViewVehicle'));
export const EditVehicle = React.lazy(() => import('./EditVehicle'));
